// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3zhEB","unreadBadge":"styles_unreadBadge__3qysL","modalContent":"styles_modalContent__3wRg1","modal":"styles_modal__18v8z"};